import { Message } from "element-ui";

export const getUrlString = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};
export const replaceUrl = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[0]);
  return null;
};
/**
 * 不同格式转换日期
 * @param date
 * @returns {Date}
 * @constructor
 */
export function dateParse(date) {
  if (!(date instanceof Date)) {
    if (typeof date === "number") {
      date = new Date(date);
    } else if (typeof date === "string" && date !== "") {
      date = date.replace(/\..+$/g, "");
      if (/\d{4}[^\d]\d{1,2}$/.test(date)) {
        date = date + "/01";
      }
      if (/\d{4}[^\d]\d{1,2}[^\d]\d{1,2}$/.test(date)) {
        date = date + " 00:00:00";
      }
      //加时区转换，底座中不带时区获取事件会有问题
      if (/\d{4}[^\d]\d{1,2}[^\d]\d{1,2}[^\d]\d{1,2}[^\d]\d{1,2}[^\d]\d{1,2}$/.test(date)) {
        date = date + "+0800";
      }
      date = date.replace(/(\d{4}[^\d]\d{1,2}[^\d]\d{1,2})[^\d](\d{1,2}[^\d]\d{1,2}[^\d]\d{1,2}(\+|-)\d{4})$/, "$1T$2");
      //单数组前补充0
      date = date.replace(/(^|[^\d])(\d)(?=[^\d]|$)/gi, "$10$2");
      date = date.replace(/[^\d:+\-T ]/g, "-");
      date = new Date(date);
    }
  }
  return date;
}

/**
 * 日期格式化
 * @param date              要格式化的日期
 * @param {string} format   日期转换格式
 * @returns {String}
 * @constructor
 */
export function dateFormat(date, format = "yyyy-MM-dd") {
  if (!date) {
    return date;
  }
  if (typeof date === "string" && !date.trim()) {
    return "";
  }
  if (!format) {
    format = "yyyy-MM-dd";
  }
  //修改为支持字符串格式的日期或date对象
  date = dateParse(date);

  let formats = {
    "y+": date.getFullYear(),
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "H+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
    "w+": ["日", "一", "二", "三", "四", "五", "六"][date.getDay()],
  };
  Object.keys(formats).forEach((key) => {
    const item = formats[key];
    format = format.replace(eval("/" + key + "/g"), function(exp) {
      return exp.length === 1 ? item : ("0" + item).substr(("0" + item).length - exp.length);
    });
  });
  return format;
}

/**
 * 防抖
 * @param {Function} Fn
 * @param {number} debounceTime
 * @returns {Function}
 * @constructor
 */

export function debounce(Fn, debounceTime = 200) {
  let timestamp = 0;
  let total = 0;
  return function(...args) {
    timestamp = Date.now();
    total++;
    //防止并发操作的时候同时被调用，用index来判断是最后一次调用的
    setTimeout(
      (_index) => {
        if (total !== _index) {
          return;
        }
        if (Date.now() < timestamp + debounceTime) {
          return;
        }
        Fn.apply(this, [...args, total]);
        total = 0;
      },
      debounceTime,
      total
    );
  };
}

export const childrenSort = (arr) => {
  arr = sort(arr);
  return arr.map((item) => {
    if (item.children && item.children.length) {
      item.children = sort(item.children);
    }
    return item;
  });
};
export const sort = (arr) => {
  if (arr.length < 2) {
    return arr;
  } else {
    const pivot = arr[0].menuOrder; // 基准值
    const pivotArr = []; // 一样大的放中间
    const lowArr = []; // 小的放左边
    const hightArr = []; // 大的放右边
    arr.forEach((current) => {
      if (current.menuOrder === pivot) pivotArr.push(current);
      else if (current.menuOrder > pivot) hightArr.push(current);
      else lowArr.push(current);
    });
    return sort(lowArr)
      .concat(pivotArr)
      .concat(sort(hightArr));
  }
};

export const Clipboard = (content) => {
  let oInput = document.createElement("input");
  oInput.value = content;
  document.body.appendChild(oInput);
  oInput.select(); // 选择对象;
  document.execCommand("Copy");
  Message.success("已复制到剪贴板");
  oInput.remove();
};

export const GetRandomField = (initial, length = 4) => {
  const alphabet = "abcdefghigklmnopqrstuvwxyz0123456789";
  let field = `${initial}`;
  for (let index = 0; index < length; index++) {
    const randomIndex = Math.floor(Math.random() * 36);
    field += alphabet[randomIndex];
  }
  return field;
};
export function xss(html) {
  const xss = require("xss")
  const whiteList = xss.getDefaultWhiteList();
  Object.keys(whiteList).forEach(key => whiteList[key].push("style"));
  var options = {
      whiteList: whiteList,
  };
  return xss(html, options);
}
